export { FastshiftPage } from './src/fastshift-page';
